export const pct = (value: number, digits = 1): string => `${(value * 100).toFixed(digits)} %`;

export const avg = (value: number | null | undefined, digits = 2): string =>
  value === null || value === undefined ? '–' : value.toFixed(digits);

/** "18:2" — the way German league tables print won:lost. */
export const record = (won: number, lost: number): string => `${won}:${lost}`;

export const score = (value: number): string => value.toFixed(3);

/**
 * The strength predictions run on. It is a 3-dart average in points, so one
 * decimal reads naturally to anyone who knows the sport.
 */
export const rating = (value: number): string => value.toFixed(1);

export const dateTime = (iso: string | null): string =>
  iso ? new Date(iso).toLocaleString('de-DE', { dateStyle: 'medium', timeStyle: 'short' }) : '–';
